import React from 'react';

import { SVGProps } from './types';

function ClockIcon(props: SVGProps) {
  const fill = props.fill || 'currentColor';
  const secondaryfill = props.secondaryfill || fill;
  const width = props.width || '100%';
  const height = props.height || '100%';

  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <g
        fill={secondaryfill}
        stroke={secondaryfill}
        strokeLinecap="square"
        strokeWidth={2}
      >
        <circle cx="12" cy="12" fill="none" r="11" stroke={fill} />
        <polyline fill="none" points=" 12,6 12,12 18,12 " />
      </g>
    </svg>
  );
}

export default ClockIcon;
